import type { FaqConfig } from "src/types/faq";

export function newSectionId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `faq-${Date.now()}`;
}

export function faqEqual(a: FaqConfig, b: FaqConfig): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}

export function moveArrayItem<T>(arr: T[], from: number, to: number): T[] {
  if (
    from === to ||
    from < 0 ||
    to < 0 ||
    from >= arr.length ||
    to >= arr.length
  ) {
    return arr;
  }
  const next = [...arr];
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
}
